// extracted by mini-css-extract-plugin
export var active = "_fo-1";
export var circle = "_fo-0";
export var completed = "_fo-2";
export var connector = "_fo-4";
export var connectorCompleted = "_fo-7";
export var connectorSpacer = "_fo-5";
export var iconStrokeOverride = "_fo-8";
export var labelContainer = "_fo-6";
export var pending = "_fo-3";